import {useListView} from './core/ListViewProvider'
import {useQueryResponse, useQueryResponseData} from './core/QueryResponseProvider'
import {QUERIES} from '../../../../../_metronic/helpers'
import {fields} from './core/_models'
import {createComment, deleteComment, updateComment} from './core/_requests'
import {KModal} from '../../../../../_component/modal/Modal'

export const ViewEditModal = () => {
  const {setItemIdForUpdate, itemIdForUpdate, setItemIdToView, itemIdToView} = useListView()
  const {refetch} = useQueryResponse()
  const designations = useQueryResponseData()

  return (
    <KModal
      model={QUERIES.COMMENT_LIST}
      title='Comment'
      setItemIdForUpdate={setItemIdForUpdate}
      itemIdForUpdate={itemIdForUpdate}
      setItemIdToView={setItemIdToView}
      itemIdToView={itemIdToView}
      fields={fields}
      data={designations}
      update={updateComment}
      create={createComment}
      delete={deleteComment}
      refetch={refetch}
    />
  )
}
